import { useState, useEffect } from 'react';
import { NavLink, Link, useLocation } from 'react-router-dom';
import logo from '../assets/logo.png';
import './Navbar.css';

const links = [
  { to: '/programme', label: 'The Programme' },
  { to: '/technology', label: 'Technology' },
  { to: '/wellbeing', label: 'Wellbeing' },
  { to: '/events', label: 'Events' },
  { to: '/about', label: 'About' },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  // Close drawer on route change
  useEffect(() => { setOpen(false); }, [location.pathname]);

  // Lock scroll when drawer open
  useEffect(() => {
    document.body.style.overflow = open ? 'hidden' : '';
    return () => { document.body.style.overflow = ''; };
  }, [open]);

  return (
    <>
      <nav className={`nav${scrolled ? ' scrolled' : ''}`}>
        <Link to="/" className="nav-brand">
          <img src={logo} alt="Chess at Sea emblem" className="nav-emblem" />
          <span className="nav-wordmark">Chess <span>at Sea</span></span>
        </Link>

        <ul className="nav-links">
          {links.map((l) => (
            <li key={l.to}>
              <NavLink to={l.to}>{l.label}</NavLink>
            </li>
          ))}
        </ul>

        <Link to="/about#contact" className="nav-cta desktop-cta">Get in Touch</Link>

        <button
          className={`nav-burger${open ? ' open' : ''}`}
          aria-label="Toggle menu"
          aria-expanded={open}
          onClick={() => setOpen((o) => !o)}
        >
          <span /><span /><span />
        </button>
      </nav>

      <div className={`nav-drawer${open ? ' open' : ''}`}>
        <NavLink to="/" end>Home</NavLink>
        {links.map((l) => (
          <NavLink key={l.to} to={l.to}>{l.label}</NavLink>
        ))}
        <Link to="/about#contact" className="nav-cta">Get in Touch</Link>
      </div>
    </>
  );
}
